import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


// Your Firebase configuration object
const firebaseConfig = {
    apiKey: "AIzaSyCLIszVrUIRrNFnRdb0GpZFv3may_6mo8o",
    authDomain: "certificateverifiication.firebaseapp.com",
    projectId: "certificateverifiication",
    storageBucket: "certificateverifiication.firebasestorage.app",
    messagingSenderId: "489783825095",
    appId: "1:489783825095:web:28ab2292715771edf524e2",
    measurementId: "G-FBVMDY2MK3"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };